import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";

const FRASES = {
  montador: "Sua agenda, oportunidades e serviços em um só lugar.",
  empresa: "Sua operação, suas regras, tudo conectado.",
  montadora: "Sua rede organizada para crescer.",
  cliente: "Acompanhe sua montagem do início à conclusão.",
  admin: "Sua operação, suas regras, tudo conectado.",
};

const hoje = () => new Date().toISOString().slice(0, 10);

export default function SplashIntro() {
  const { user } = useAuth();
  const [visivel, setVisivel] = useState(false);
  const [saindo, setSaindo] = useState(false);
  const [fase, setFase] = useState(0); // 0=vídeo, 1=+nome, 2=+frase
  const [fallback, setFallback] = useState(false);
  const videoRef = useRef(null);
  const timers = useRef([]);

  useEffect(() => {
    if (!user) return;
    if (sessionStorage.getItem("mj_splash_pending") !== "1") return;
    sessionStorage.removeItem("mj_splash_pending");
    const chaveDia = `mj_splash_day_${user.id || user.email}`;
    if (localStorage.getItem(chaveDia) === hoje()) return;
    localStorage.setItem(chaveDia, hoje());
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    setVisivel(true);
    timers.current.push(setTimeout(() => setFase(1), 2600));
    timers.current.push(setTimeout(() => setFase(2), 3400));
    // Segurança: nunca prender o usuário por mais de 7s
    timers.current.push(setTimeout(() => fechar(), 7000));
    // Se o vídeo não começar em 3s (rede lenta), mostra logo estático e libera
    timers.current.push(setTimeout(() => {
      const v = videoRef.current;
      if (v && v.currentTime === 0 && v.paused) {
        setFallback(true);
        setFase(2);
        setTimeout(() => fechar(), 1200);
      }
    }, 3000));
    return () => timers.current.forEach(clearTimeout);
    // eslint-disable-next-line
  }, [user]);

  const fechar = () => {
    setSaindo(true);
    setTimeout(() => setVisivel(false), 450);
  };

  if (!visivel || !user) return null;
  const frase = FRASES[user.role] || FRASES.empresa;

  return (
    <div data-testid="splash-intro"
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#0A174A] transition-opacity duration-500 ${saindo ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
      <button onClick={fechar} data-testid="splash-pular"
        className="absolute top-4 right-5 px-4 py-1.5 rounded-full text-xs font-bold text-white/80 border border-white/30 hover:bg-white/10 transition-colors">
        Pular
      </button>
      {!fallback ? (
        <video ref={videoRef} src="/media/montaja-intro.mp4" autoPlay muted playsInline
          onEnded={fechar}
          onError={() => { setFallback(true); setFase(2); setTimeout(fechar, 1200); }}
          className="w-full h-full object-cover sm:object-contain sm:max-h-[70vh] sm:w-auto"
          data-testid="splash-video" />
      ) : (
        <div className="text-6xl font-black text-white tracking-tight">M</div>
      )}
      <div className="absolute bottom-[16%] inset-x-0 flex flex-col items-center gap-2 px-6 text-center pointer-events-none">
        <div className={`text-3xl sm:text-4xl font-black text-white tracking-tight transition-all duration-700 ${fase >= 1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}
          data-testid="splash-nome">
          Monta<span className="text-[#FF6700]">Já</span>
        </div>
        <div className={`text-sm sm:text-base text-white/85 max-w-md transition-all duration-700 ${fase >= 2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}
          data-testid="splash-frase">
          Bem-vindo, {(user.name || "").split(" ")[0] || user.email}! {frase}
        </div>
      </div>
    </div>
  );
}
